module.exports = __webpack_public_path__ + "static/img/couponDefault.1856f4c8.png";